import { TranslateModule } from '@ngx-translate/core';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';
import { NgIf } from '@angular/common';

import { SupplierInputComponent } from '../supplier-input';

import { Locale, Maybe, Role, Supplier } from '@iss/libs/graphql';
import {
  LabelDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  Control,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-supplier-field',
  templateUrl: './supplier-field.component.html',
  standalone: true,
  imports: [
    FormFieldComponent,
    FormFieldErrorDirective,
    LabelDirective,
    NgIf,
    ReactiveFormsModule,
    SupplierInputComponent,
    TranslateModule,
  ],
})
export class SupplierFieldComponent {
  @Input() public label: Maybe<string>;
  @Input() public withAll: Maybe<boolean>;
  @Input() public readonly: Maybe<boolean>;
  @Input() public placeholder: Maybe<string>;
  @Input() public available: Maybe<readonly Supplier['id'][]>;
  @Input() public role: Maybe<Role>;
  @Input() public country: Maybe<Locale>;
  @Input() public isTreatmentFacility: Maybe<boolean>;
  @Input() public multi: Maybe<boolean>;
  @Input() public loading: Maybe<boolean>;
  @Input() public showNecessity = true;
  @Input() public forceTypeahead: Maybe<boolean>;
  @Input() public clearable = true;
  @Input() public secondaryLabelFn: (supplier: Supplier['id']) => Maybe<string> = () => null;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
